// How a value is shown, by the kind of its column. Shared by the table and the tiles so both say
// the same thing about a row.
//
// A date column stores ISO (the server normalises whatever was written); it is shown day first,
// as the office writes dates and as the source workbook has them. A value that is not ISO - "TBC",
// or a row written before the column was typed and not yet normalised - is shown as it is.

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

export const isIsoDate = (value) => ISO_DATE.test(value ?? '');

// A multiline value keeps its line breaks in a cell; the class is the CSS's cue.
export const cellClass = (column) => (column.multiline ? 'multiline' : undefined);

export function display(column, value) {
  if (value === null || value === undefined) return '';
  if (column.kind === 'date') {
    const match = ISO_DATE.exec(value);
    if (match) return `${match[3]}/${match[2]}/${match[1]}`;
  }
  return value;
}
